import { useEffect, useState } from 'react';
import { fetchPublishedEpisodes } from '../../utils/fgtnApi';
import { searchSitePages } from '../../domain/siteSearch';

let cached;
let pending;
export default function useSearchPages(query) {
  const [episodes, setEpisodes] = useState(cached?.rows || []);
  const [error, setError] = useState(false);
  useEffect(() => {
    if (query.trim().length < 2) return undefined;
    let cancelled = false;
    if (!pending) pending = (cached && Date.now() - cached.at < 300000 ? Promise.resolve(cached.rows) : fetchPublishedEpisodes()).then(rows => { cached = { rows, at: Date.now() }; return rows; }).finally(() => { pending = null; });
    pending.then(rows => { if (!cancelled) { setEpisodes(rows); setError(false); } }).catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, [query]);
  return { pages: searchSitePages(query, episodes), error };
}
